var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8749 2.39624C20.4674 2.41813 19.0905 2.81106 17.8834 3.53533C16.6763 4.2596 15.6816 5.28958 14.9999 6.52124C14.3182 5.28958 13.3236 4.2596 12.1165 3.53533C10.9094 2.81106 9.53251 2.41813 8.12495 2.39624C5.88112 2.49373 3.76708 3.47531 2.24468 5.12653C0.722272 6.77775 -0.0847403 8.9644 -5.21373e-05 11.2087C-5.21373e-05 16.8925 5.98245 23.1 10.9999 27.3087C12.1202 28.2502 13.5366 28.7663 14.9999 28.7663C16.4633 28.7663 17.8797 28.2502 18.9999 27.3087C24.0174 23.1 29.9999 16.8925 29.9999 11.2087C30.0846 8.9644 29.2776 6.77775 27.7552 5.12653C26.2328 3.47531 24.1188 2.49373 21.8749 2.39624ZM17.3937 25.3962C16.7237 25.9605 15.8759 26.2699 14.9999 26.2699C14.124 26.2699 13.2762 25.9605 12.6062 25.3962C6.1837 20.0075 2.49995 14.8375 2.49995 11.2087C2.4145 9.62714 2.95791 8.0759 4.01165 6.89336C5.0654 5.71083 6.54399 4.99293 8.12495 4.89624C9.7059 4.99293 11.1845 5.71083 12.2382 6.89336C13.292 8.0759 13.8354 9.62714 13.7499 11.2087C13.7499 11.5403 13.8816 11.8582 14.1161 12.0926C14.3505 12.327 14.6684 12.4587 14.9999 12.4587C15.3315 12.4587 15.6494 12.327 15.8838 12.0926C16.1182 11.8582 16.2499 11.5403 16.2499 11.2087C16.1645 9.62714 16.7079 8.0759 17.7617 6.89336C18.8154 5.71083 20.294 4.99293 21.8749 4.89624C23.4559 4.99293 24.9345 5.71083 25.9882 6.89336C27.042 8.0759 27.5854 9.62714 27.4999 11.2087C27.4999 14.8375 23.8162 20.0075 17.3937 25.3912V25.3962Z",
    fill: "#0B3F37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.aed973a7be946870ec60e0eff344b3a7.svg";
export { ForwardRef as ReactComponent };